module.exports = __webpack_public_path__ + "img/1490931468.06b887ec.jpg";